<template>
  <div class="info_cheartInfo">
    <el-card style="height:100%">
      <p>各行业中企央企数量分析</p>
      <div ref="ehachrValue" class="ehcartds" style="height:90%"></div>
    </el-card>
  </div>
</template>

<script>
import { infoDataSetGir } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.handEcharts();
  },
  methods: {
    async getSetGir() {},
    handEcharts(dataInfo) {
      let echarts = this.$echarts.init(this.$refs.ehachrValue);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        // legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: [
            "A.农、林、牧、渔业",
            "B.采矿业",
            "C.制造业",
            "D.电力、热力、燃气及水生产和供应业",
            "E.建筑业",
            "F.批发和零售业",
            "G交通运输、仓储和邮政业",
            "H. 住宿和餐饮业",
            "I. 信息传输、计算机服务和软件业",
            "J.金融业",
          ],
        },
        series: [
          {
            name: "中央企业数量",
            type: "bar",
            barGap: "100%",
            label: {
              show: false,
            },
            itemStyle: {
              color: "#C12DBF",
            },
            emphasis: {
              focus: "series",
            },
            z: 2,
            data: [320, 302, 301, 334, 390, 330, 320, 350, 600, 100],
          },
          {
            //灰色背景条
            name: "企业总数",
            type: "pictorialBar",
            symbol: "rect",
            data: [320, 302, 301, 334, 390, 330, 320, 350, 500, 800],
            itemStyle: {
              color: "#eee",
            },
            emphasis: {
              itemStyle: {
                color: "#eee",
              },
            },
            z: 1,
          },
        ],
      };
      echarts.setOption(option);
    },
  },
};
</script>

<style lang="less">
.info_cheartInfo {
  margin-top: 15px;
  height: 600px;
  .el-card__body {
    height: 100%;
  }
}
</style>
